/**
 * Custom vee-validate rules shared by the app plugin (vee-validate.js)
 * and the jest setup (tests/setup.js), so specs that mount forms using
 * these rules don't blow up with "No such validator ... exists".
 */
export default {
    verify_password: {
        getMessage: () =>
            `Password must contain at least: 1 uppercase letter, 1 lowercase letter`,
        validate: value => {
            var strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])');
            return strongRegex.test(value);
        }
    },
    meditation_name: {
        getMessage: () =>
            `Name should include at least one number or letter. The allowed special characters are - space, at-sign, hypen, underscore, period, comma, apostrophe and semicolon`,
        validate: value => {
            var strongRegex = new RegExp(
                "^(?=.*[a-zA-Z0-9])[a-zA-Z0-9,'`.!?\\-|_@:; ]*$"
            );
            return strongRegex.test(value);
        }
    }
};
